var map = {
	"./article": 2034,
	"./article.jpg": 2034,
	"./article__mob": 2035,
	"./article__mob.jpg": 2035,
	"./background": 2036,
	"./background.png": 2036,
	"./background_fruits": 2037,
	"./background_fruits.png": 2037,
	"./background_granola": 2038,
	"./background_granola.png": 2038,
	"./contest": 2039,
	"./contest.png": 2039,
	"./green_subs": 2040,
	"./green_subs.png": 2040,
	"./leaves": 2041,
	"./leaves.png": 2041,
	"./logo": 34,
	"./logo.png": 34,
	"./logo.svg": 2337,
	"./oleg": 2042,
	"./oleg.png": 2042,
	"./play": 2043,
	"./play.svg": 2043,
	"./products/prod_1": 2044,
	"./products/prod_1.png": 2044,
	"./products/prod_2": 2045,
	"./products/prod_2.png": 2045,
	"./products/prod_3": 2046,
	"./products/prod_3.png": 2046,
	"./products/prod_4": 2047,
	"./products/prod_4.png": 2047,
	"./products/prod_5": 2048,
	"./products/prod_5.png": 2048,
	"./products/prod_6": 2049,
	"./products/prod_6.png": 2049,
	"./products/prod_7": 2050,
	"./products/prod_7.png": 2050,
	"./products/prod_8": 2051,
	"./products/prod_8.png": 2051,
	"./products_back": 2052,
	"./products_back.png": 2052,
	"./recipes/recipe_1": 2053,
	"./recipes/recipe_1.jpg": 2053,
	"./recipes/recipe_10": 2054,
	"./recipes/recipe_10.jpg": 2054,
	"./recipes/recipe_2": 2055,
	"./recipes/recipe_2.jpg": 2055,
	"./recipes/recipe_3": 2056,
	"./recipes/recipe_3.jpg": 2056,
	"./recipes/recipe_4": 2057,
	"./recipes/recipe_4.jpg": 2057,
	"./recipes/recipe_5": 2058,
	"./recipes/recipe_5.jpg": 2058,
	"./recipes/recipe_6": 2059,
	"./recipes/recipe_6.jpg": 2059,
	"./recipes/recipe_7": 2060,
	"./recipes/recipe_7.jpg": 2060,
	"./recipes/recipe_8": 2061,
	"./recipes/recipe_8.jpg": 2061,
	"./recipes/recipe_9": 2062,
	"./recipes/recipe_9.jpg": 2062,
	"./tasty_granola": 2063,
	"./tasty_granola.png": 2063,
	"./test": 2064,
	"./test.png": 2064,
	"./test__mob": 2065,
	"./test__mob.png": 2065,
	"./tgShare": 2066,
	"./tgShare.svg": 2066,
	"./top_products/prod_1": 2067,
	"./top_products/prod_1.png": 2067,
	"./top_products/prod_1__mob": 2068,
	"./top_products/prod_1__mob.png": 2068,
	"./top_products/prod_2": 2069,
	"./top_products/prod_2.png": 2069,
	"./top_products/prod_2__mob": 2070,
	"./top_products/prod_2__mob.png": 2070,
	"./top_products/prod_3": 2071,
	"./top_products/prod_3.png": 2071,
	"./top_products/prod_3__mob": 2072,
	"./top_products/prod_3__mob.png": 2072,
	"./top_subs": 2073,
	"./top_subs.png": 2073,
	"./velleShare": 2074,
	"./velleShare.svg": 2074,
	"./vkShare": 2075,
	"./vkShare.svg": 2075,
	"./white_subs": 2076,
	"./white_subs.png": 2076,
	"./zenShare": 2077,
	"./zenShare.svg": 2077
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2336;